<div class="support-buttons-container">
    <div class="d-flex align-items-center no-gutters">
        <div class="col-6 first-col">
            <a class="btn btn-block btn-social btn-warning w-100" (click)="onPatreonClick()">
                <i class="background-patreon"></i><span [translate]="'support_buttons.patreon'"></span>
            </a>
        </div>
        <div class="col-6 second-col">
            <a class="btn btn-block btn-social btn-info w-100" (click)="onKofiClick()">
                <i class="background-kofi"></i><span [translate]="'support_buttons.kofi'"></span>
            </a>
        </div>
    </div>
</div>
